"use strict";

// variables
import { mq } from './variables.js';

// ap
import * as ap from './animation_ap-site.js';

// slick-slider
const sliderJs = require('./slick-slider.js');

//require('./menu-button-links.js');

// onload
function load() {
  sliderJs.tourSlider.slick(sliderJs.tourSliderOptions);
  sliderJs.jobsSlider.slick(sliderJs.jobsSliderOptions);
  sliderJs.ergoSlider.slick(sliderJs.ergoSliderOptions);
  if (mq.lg.matches) {
    ap.initApSite();
  }
};
window.onload = load;

// onresize
//function resize() {
  //ap.initApSite(mq.lg.matches, 1);
//}
//window.onresize = resize;
